import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';

export interface FamilyRelationshipResponse {
  Id: number;
  Name: string;
}

export interface FamilyRelationshipOption {
  id: string;
  name: string;
}

export const familyRelationshipsApi = createApi({
  reducerPath: 'familyRelationshipsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/web-api/api',
  }),
  endpoints: (builder) => ({
    getFamilyRelationships: builder.query<FamilyRelationshipOption[], void>({
      query: () => ({
        url: `/basedata/familyrelationships`,
        method: 'get',
      }),
      transformResponse: (options: FamilyRelationshipResponse[]) =>
        options.map((option) => ({
          id: option.Id.toString(),
          name: option.Name,
        })),
    }),
  }),
});

export const { useGetFamilyRelationshipsQuery } = familyRelationshipsApi;
